module.exports = __webpack_public_path__ + "static/media/locations16.ea3f65ed.png";